// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"index-module--wrapper--1d6MA","video":"index-module--video--1aHHC"};